import { DetailedPlayerType } from "@/pages/DetailedPlayer/DetailedPlayer";
import { PlayStylesLabRecommendation } from "@/redux/playStylesLab/playStylesLabSlice";
import type { ResponseEvolutionStep } from "@repo/shared/api";
import { evolutionPathPair } from "@repo/shared/evolutions";

import axios from "../../../api";

export type PlayStylesLabResponse = {
  baseStep: DetailedPlayerType;
  currentStep?: ResponseEvolutionStep;
  detailedPlayer: DetailedPlayerType;
  recommendations: PlayStylesLabRecommendation[];
  allPlayStyles: PlayStylesLabRecommendation[];
};

export const calculatePlayStylesLab = async ({
  resourceId,
  assetId,
  labPlayStylesPlus,
  labPlayStyles,
  playerRoleId,
  evoPathId,
  evolutionPath,
  pathwayPath,
}: {
  resourceId: number;
  assetId: number;
  labPlayStylesPlus: number[];
  labPlayStyles: number[];
  playerRoleId?: number;
  evoPathId?: string;
  evolutionPath?: number[];
  pathwayPath?: number[][];
}) => {
  const res = await axios.post<PlayStylesLabResponse>(
    `/players/${resourceId}/playstyles-lab/`,
    {
      assetId,
      labPlayStylesPlus,
      labPlayStyles,
      playerRoleId,
      ...(evoPathId && { evoPathId }),
      ...(evolutionPath && evolutionPathPair(evolutionPath, pathwayPath)),
    },
  );
  return res.data;
};
